import ImageTile from "@/components/TilesModule/variants/TilesManagement/ImageTile";
import RestTile from "@/components/TilesModule/variants/TilesManagement/RestTile";

export default function Tile({data, isLastTile, index, isLastItemHovered, handleClickLastElement}) {
	return (
		<>
			<ImageTile
				data={data}
				index={index}
				isLastTile={isLastTile}
				isLastElementHovered={isLastItemHovered}
				handleClickLastElement={handleClickLastElement}
			/>
			<RestTile
				data={data}
				index={index}
				isLastTile={isLastTile}
				isLastElementHovered={isLastItemHovered}
				handleClickLastElement={handleClickLastElement}
			/>
		</>
	)
}